import { z } from 'zod';

export const ModuleSchema = z
  .object({
    subject: z.string(),
    grade: z.string(),
  })
  .refine(
    data => {
      const hasSubject = data.subject && data.subject.trim().length > 0;
      const hasGrade = data.grade && data.grade.trim().length > 0;
      // if both are empty, it's valid (will be filtered out)
      if (!hasSubject && !hasGrade) return true;
      // if either has data, both must have data
      return hasSubject && hasGrade;
    },
    data => {
      const hasSubject = data.subject && data.subject.trim().length > 0;
      const hasGrade = data.grade && data.grade.trim().length > 0;

      if (!hasSubject && hasGrade) {
        return { message: "Subject can't be empty", path: ['subject'] };
      }
      if (hasSubject && !hasGrade) {
        return { message: "Grade can't be empty", path: ['grade'] };
      }

      return { message: "Subject can't be empty", path: ['subject'] };
    },
  )
  .refine(
    data => {
      if (data.subject && data.subject.length > 100) return false;
      return true;
    },
    { message: 'Subject is too long.', path: ['subject'] },
  )
  .refine(
    data => {
      if (data.grade && data.grade.length > 100) return false;
      return true;
    },
    { message: 'Grade is too long.', path: ['grade'] },
  );
